import React from 'react'
import { Route } from 'react-router'

// import Layout from '../component/Layout';
// import EmptyLayout from '../component/EmptyLayout';
// import LiveVideoLayout from '../component/LiveVideoLayout';
// import Auth from '../component/Auth';
import AdvancedPlayerPermalink from '../component/smart/permalinks/AdvancedPlayerPermalink'

export default (
	<Route>
		<Route path="/player/permalink/:permalinkID" component={AdvancedPlayerPermalink} />
		<Route exact path="/event/permalink/:eventHash" component={AdvancedPlayerPermalink} />
	</Route>
)
